<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    top="10vh"
    width="90%"
    :title="
      billType === 'stockReturn' || 'stockBatchReturn'
        ? $l('INDEX.stock_title_choose_borrow_item') || '选择外借样品'
        : billType === 'stockSellReturn'
        ? $l('INDEX.stock_title_choose_sell_item') || '选择已售样品'
        : $l('INDEX.stock_title_choose_stock_item') || '选择库存样品'
    "
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    v-el-dialog-drag
    append-to-body
  >
    <choose-sample-stock
      ref="chooseSampleInner"
      :type="type"
      :billType="billType"
    />
    <span slot="footer">
      <el-button v-if="!type" size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button v-if="type" size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button v-if="type" type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    type: String,
    billType: String
  },
  methods: {
    confirm() {
      const data = this.$refs.chooseSampleInner.choiceData()
      if (!data) return

      this.$emit('confirm', data)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>
